module.exports = __webpack_public_path__ + "static/media/Sticker.599c9d0a.png";